/** True when the given employee profile belongs to the logged-in user. */
export function isOwnEmployeeProfile(employeeId) {
    const loggedInId = sessionStorage.getItem("employee_id");
    if (!loggedInId || employeeId == null || employeeId === "") {
        return false;
    }
    return String(employeeId) === String(loggedInId);
}

export const REMARKS_SELF_VIEW_MESSAGE =
    "Remarks are manager and HR notes about an employee. You cannot view or add remarks on your own profile.";
